module.exports = {
    returnName: {
        0: 'Selecione',
        1: 'Administrador',
        2: 'Contratante',
    },
};
